export default "__VITE_ASSET__BKR6F2Q2__"